module.exports = __webpack_public_path__ + "static/media/hunter-cat.9ce8d045.svg";